

import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

const CheckIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-brand-green" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
);

interface SubscriptionProps {
  isB2BView: boolean;
}

const Subscription: React.FC<SubscriptionProps> = ({ isB2BView }) => {
  const { t } = useTranslation();
  
  const title = isB2BView ? t('b2b_sub_title') : t('sub_title');
  const text = isB2BView ? t('b2b_sub_text') : t('sub_text');
  const perk1 = isB2BView ? t('b2b_perk1') : t('perk1');
  const perk2 = isB2BView ? t('b2b_perk2') : t('perk2');
  const perk3 = isB2BView ? t('b2b_perk3') : t('perk3');
  const imageSrc = isB2BView 
    ? "https://papirrullen.clientdemo.app/assets/images/b2b-subscription.jpg" 
    : "https://papirrullen.clientdemo.app/assets/images/koala2.jpg";


  return (
    <section id="subscription" className="py-24 bg-brand-green-light/40 dark:bg-brand-dark">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold font-serif text-brand-dark dark:text-white">{title}</h2>
            <p className="mt-4 text-lg text-slate-600 dark:text-slate-300">
              {text}
            </p>
            <ul className="mt-6 space-y-4">
              <li className="flex items-start">
                <CheckIcon />
                <span className="ml-3 text-slate-700 dark:text-slate-300" dangerouslySetInnerHTML={{ __html: perk1 }}></span>
              </li>
              <li className="flex items-start">
                <CheckIcon />
                <span className="ml-3 text-slate-700 dark:text-slate-300" dangerouslySetInnerHTML={{ __html: perk2 }}></span>
              </li>
              <li className="flex items-start">
                <CheckIcon />
                <span className="ml-3 text-slate-700 dark:text-slate-300" dangerouslySetInnerHTML={{ __html: perk3 }}></span>
              </li>
            </ul>
            <a 
              href="/#/products"
              className="mt-8 inline-block bg-brand-dark text-white font-bold text-lg px-8 py-3 rounded-lg shadow-lg hover:bg-brand-green transition-colors duration-300"
            >
              {t('choose_products_btn')}
            </a>
          </div>
          <div className="flex justify-center">
            <img src={imageSrc} alt="Subscription box" className="rounded-xl shadow-2xl" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Subscription;